export const sanitizeReturnTo = (path) => {
  if (typeof path !== 'string' || !path.startsWith('/') || path.startsWith('//')) return '/';
  if (path.startsWith('/login')) return '/';
  return path;
};

export const chooseReturnTo = (...candidates) => {
  const selected = candidates.find((candidate) => typeof candidate === 'string' && candidate.length > 0);
  return sanitizeReturnTo(selected || '/');
};
